import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyFormat'
})
export class CurrencyFormatPipe implements PipeTransform {
  transform(value: number | string): string {
    // If the value is null, undefined, or an empty string, return ₹0.00
    if (value == null || value === '') {
      return '₹0.00';
    }

    // Convert to a number
    const amount = Number(value);

    // If the value is 0, format it as ₹0.00
    if (amount === 0) {
      return '₹0.00';
    }

    // For all other values, format as currency
    return amount.toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
  }
}
